import styled from 'styled-components';
import { IoAlertCircle, IoCheckmarkCircle, IoInformationCircle } from 'react-icons/io5';

const ICONS = {
  error: IoAlertCircle,
  success: IoCheckmarkCircle,
  info: IoInformationCircle,
};

const COLORS = {
  error: '#EF4444',
  success: '#22C55E',
  info: '#3B82F6',
};

/**
 * 공통 알림 모달
 * - 로그인 에러/승인대기/성공 등 범용
 *
 * props:
 *  - type: 'error' | 'success' | 'info' (default 'error')
 *  - title: 타이틀
 *  - message: 본문 (줄바꿈 지원)
 *  - confirmText: 버튼 텍스트 (default '확인')
 *  - onConfirm: 확인 클릭 시 호출
 */
const AlertModal = ({ type = 'error', title, message, confirmText = '확인', onConfirm }) => {
  const Icon = ICONS[type] || IoAlertCircle;
  const color = COLORS[type] || COLORS.error;

  return (
    <Overlay>
      <Box>
        <IconCircle $color={color}>
          <Icon size={36} />
        </IconCircle>
        {title && <Title>{title}</Title>}
        {message && <Message>{message}</Message>}
        <ConfirmBtn type="button" onClick={onConfirm}>
          {confirmText}
        </ConfirmBtn>
      </Box>
    </Overlay>
  );
};

export default AlertModal;

// ───── 스타일 ─────
const Overlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 200;
  padding: ${({ theme }) => theme.spacing.lg};
`;

const Box = styled.div`
  width: 100%;
  max-width: 320px;
  background: #fff;
  border-radius: ${({ theme }) => theme.radius.lg};
  padding: ${({ theme }) => theme.spacing.xl};
  text-align: center;
`;

const IconCircle = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 64px;
  height: 64px;
  margin: 0 auto ${({ theme }) => theme.spacing.md};
  color: ${({ $color }) => $color};
  background: ${({ $color }) => $color}15;
  border-radius: 50%;
`;

const Title = styled.h3`
  font-size: ${({ theme }) => theme.fontSize.lg};
  font-weight: ${({ theme }) => theme.fontWeight.bold};
  color: ${({ theme }) => theme.colors.text};
  margin: 0 0 ${({ theme }) => theme.spacing.sm};
`;

const Message = styled.p`
  font-size: ${({ theme }) => theme.fontSize.sm};
  color: ${({ theme }) => theme.colors.textSecondary};
  line-height: 1.6;
  margin: 0 0 ${({ theme }) => theme.spacing.lg};
  white-space: pre-line;
`;

const ConfirmBtn = styled.button`
  width: 100%;
  padding: 14px;
  background: ${({ theme }) => theme.colors.primary};
  color: #fff;
  border: 0;
  border-radius: ${({ theme }) => theme.radius.md};
  font-size: ${({ theme }) => theme.fontSize.md};
  font-weight: ${({ theme }) => theme.fontWeight.bold};
  cursor: pointer;

  &:hover { opacity: 0.9; }
`;
